import React from 'react';

const GdprPage = () => {
    return (
        <>
            <h3>Informácie o spracúvaní osobných údajov podľa GDPR</h3>
            <h4>Prevádzkovateľ osobných údajov:</h4>
            rovenski s. r. o.<br/>
            Rovenská 668/2, 905 01 Senica<br/>
            IČO: 56703236<br/>
            E-mail: info@formafitness.sk<br/>
            <p className={'my-3'}>V súlade s Nariadením Európskeho parlamentu a Rady (EÚ) 2016/679 o ochrane fyzických
                osôb pri spracúvaní osobných údajov (GDPR) a zákonom č. 18/2018 Z. z. o ochrane osobných údajov Vám
                poskytujeme tieto informácie:</p>
            <h4>1. Účely spracúvania osobných údajov</h4>
            <p className={'my-3'}>V momente, keď ste cez náš rezervačný a registračný systém schválili všeobecné
                obchodné a zmluvné podmienky („VOP“), prípadne pri vstupe do prevádzky FORMA - Fitness & Gym, alebo – v
                prípade osôb mladších ako 18 rokov – prostredníctvom registračného formulára vyplneného ich zákonným
                zástupcom, došlo k uzatvoreniu zmluvného vzťahu o poskytovaní služieb.<br/><br/>
                Osobné údaje, ktoré ste pri registrácii uviedli – predovšetkým meno, priezvisko, e-mailová adresa,
                telefónne číslo – ako aj údaje týkajúce sa rezervácií a čerpania služieb, informácie o zakúpenom
                kredite a realizovaných platbách za služby, spracúvame za účelom poskytovania našich služieb, správy
                skupinových cvičení, evidencie a využitia predplateného kreditu, ako aj riadneho zúčtovania
                platieb.<br/><br/>
                Základom spracovania týchto údajov je plnenie zmluvy podľa čl. 6 ods. 1 písm. b).<br/><br/>
                Poskytnutie osobných údajov je zmluvnou požiadavkou nevyhnutnou na uzatvorenie a plnenie zmluvy o
                poskytovaní služieb; bez ich poskytnutia nie je možné vykonať registráciu ani poskytovať Vám
                služby.<br/><br/>
                Po ukončení zmluvného vzťahu budeme osobné údaje naďalej uchovávať a spracúvať na základe nášho
                oprávneného záujmu, ktorým je možnosť preukazovať, uplatňovať a obhajovať naše právne nároky. Tieto
                údaje uchovávame zvyčajne po dobu 4 rokov od momentu skončenia zmluvného vzťahu.<br/><br/>
                Vaše osobné údaje spracúvame na tieto účely:
                <ul>
                    <li>registrácia a vedenie členskej evidencie,</li>
                    <li>rezervácie tréningov a služieb prostredníctvom systému iClub.sk,</li>
                    <li>správa platieb a vyúčtovaní,</li>
                    <li>zabezpečenie vstupu do fitness centra (QR kód),</li>
                    <li>monitorovanie priestorov z dôvodu ochrany zdravia, majetku a bezpečnosti prostredníctvom
                        kamerového systému,
                    </li>
                    <li>plnenie zákonných povinností (účtovníctvo, dane),</li>
                    <li>marketing a zasielanie informácií o novinkách (na základe dobrovoľného súhlasu, prípadne na
                        základe oprávneného záujmu, ak ste našim klientom – bližšie v časti Marketing nižšie),
                    </li>
                    <li>meranie telesného zloženia InBody na základe osobitného súhlasu (bližšie v časti Meranie
                        telesného zloženia InBody nižšie).
                    </li>
                </ul>
                Pri spracúvaní Vašich osobných údajov nedochádza k automatizovanému rozhodovaniu ani profilovaniu s
                právnymi účinkami na Vašu osobu.
            </p>
            <h4>2. Právny základ spracúvania</h4>
            <p className={'my-3'}>Vaše údaje spracúvame na základe:
                <ul>
                    <li>plnenia zmluvy – registrácia a poskytovanie služieb (čl. 6 ods. 1 písm. b),</li>
                    <li>zákonnej povinnosti – účtovné a daňové predpisy (čl. 6 ods. 1 písm. c)),</li>
                    <li>oprávneného záujmu – ochrana majetku a bezpečnosti (čl. 6 ods. 1 písm. f)),</li>
                    <li>súhlasu – marketingová komunikácia (čl. 6 ods. 1 písm. a)),</li>
                    <li>osobitného výslovného súhlasu – meranie telesného zloženia InBody, keďže ide o údaje o
                        zdraví (čl. 6 ods. 1 písm. a) a čl. 9 ods. 2 písm. a) GDPR).
                    </li>
                </ul></p>
            <h4>3. Kategórie spracúvaných údajov</h4>
            <p className={'my-3'}>
                <ul>
                    <li>meno a priezvisko,</li>
                    <li>e-mailová adresa, telefónne číslo,</li>
                    <li>údaje o členstve, vstupoch, rezerváciách,</li>
                    <li>ID v systéme iClub.sk,</li>
                    <li>záznamy z kamerového systému,</li>
                    <li>platobné a fakturačné údaje,</li>
                    <li>v prípade využitia služby InBody: údaje o telesnom zložení (bližšie v časti Meranie
                        telesného zloženia InBody nižšie).
                    </li>
                </ul>
            </p>
            <h4>4. Meranie telesného zloženia InBody</h4>
            <p className={'my-3'}>V prípade, že využijete službu merania telesného zloženia prístrojom InBody 270s,
                spracúvame Vaše meno, priezvisko, vek/dátum narodenia, pohlavie, výšku a namerané telesné parametre
                (napr. percento telesného tuku, svalovú hmotu, množstvo vody v tele, viscerálny tuk, bazálny
                metabolizmus). Tieto údaje sú svojou povahou údajmi o zdraví v zmysle čl. 9 GDPR.</p>
            <p className={'my-3'}>Právnym základom spracúvania je Váš výslovný súhlas (čl. 6 ods. 1 písm. a) a čl. 9
                ods. 2 písm. a) GDPR), ktorý udeľujete samostatným dokumentom pred prvým meraním. Bez udelenia tohto
                súhlasu nie je možné meranie vykonať.</p>
            <p className={'my-3'}>Namerané údaje sú uložené na cloudovom úložisku spoločnosti InBody Co., Ltd. so
                sídlom v Kórejskej republike, ktorá vystupuje ako sprostredkovateľ spracúvania. Prenos je
                uskutočňovaný na základe rozhodnutia Európskej komisie o primeranosti ochrany osobných údajov v
                Kórejskej republike zo dňa 17. 12. 2021.</p>
            <p className={'my-3'}>Údaje z merania uchovávame po dobu 24 mesiacov od posledného merania, prípadne po
                dobu trvania zakúpeného balíka meraní predĺženú o čas potrebný na porovnanie výsledkov, najviac však 3
                roky od posledného merania.</p>
            <p className={'my-3'}>Súhlas so spracúvaním týchto údajov môžete kedykoľvek odvolať bez uvedenia dôvodu a
                bez vplyvu na zákonnosť spracúvania pred jeho odvolaním; odvolanie súhlasu má za následok, že Vám
                nebudeme môcť naďalej poskytovať službu merania InBody. Podrobnosti sú uvedené v samostatnom dokumente
                „Súhlas so spracúvaním osobných údajov osobitnej kategórie – InBody“, ktorý podpisujete pred prvým
                meraním.</p>
            <h4>5. Záznamy z kamerového systému</h4>
            <p className={'my-3'}>V priestoroch FORMA - Fitness & Gym je nainštalovaných celkovo päť bezpečnostných
                kamier. Kamerové záznamy slúžia najmä na predchádzanie bezpečnostným incidentom, ako sú krádeže, fyzické
                ohrozenie osôb (zákazníkov aj návštevníkov), výtržnosti či iné udalosti, ktoré by mohli predstavovať
                priestupok alebo trestný čin, prípadne by mohli spôsobiť škodu nám alebo tretím stranám. Záznamy tiež
                využívame na riešenie týchto udalostí v rámci priestupkových, trestných či iných právnych konaní, kde si
                chránime alebo uplatňujeme naše zákonné nároky.</p>
            <p className={'my-3'}>Kamera umiestnená pri vstupe má okrem toho špecifickú funkciu – pomáha overovať
                dodržiavanie pravidiel uvedených vo Všeobecných obchodných podmienkach a pokynov pri vstupe, najmä pri
                kontrole možného zneužitia alebo neoprávneného použitia vstupného QR kódu.</p>
            <p className={'my-3'}>Osobné údaje získané kamerovým systémom teda spracúvame z dôvodu ochrany zdravia a
                majetku osôb nachádzajúcich sa v objekte a zároveň pre účely uplatňovania, preukazovania a obhajoby
                našich právnych záujmov. Právnym základom pre toto spracúvanie je náš oprávnený záujem na predchádzaní
                incidentom a na ochrane právnych nárokov.</p>
            <p className={'my-3'}>Kamerové záznamy uchovávame štandardne po dobu 14 dní. Ak sa však na zázname nachádza
                udalosť, ktorá má súvis s vyššie uvedenými situáciami (napr. bezpečnostný incident), takýto záznam
                uchovávame až do uzavretia príslušného konania alebo do momentu, kedy sú všetky nároky v danej veci
                vyriešené.</p>
            <h4>6. Účtovná agenda</h4>
            <p className={'my-3'}>Údaje týkajúce sa obsahu poskytovaných služieb, predplateného kreditu a uskutočnených
                platieb spracúvame aj na účely vedenia účtovníctva a plnenia daňových povinností. Právnym základom
                takéhoto spracúvania je splnenie zákonnej povinnosti podľa platných právnych predpisov, najmä zákona č.
                431/2002 Z. z. o účtovníctve. Tieto údaje uchovávame po dobu stanovenú osobitnými právnymi predpismi,
                spravidla po dobu 10 rokov.</p>

            <h4>7. Marketing</h4>
            <p className={'my-3'}>Na marketingové účely spracúvame Vaše osobné údaje na základe Vášho výslovného
                súhlasu, a to až do jeho odvolania. Udelenie súhlasu je dobrovoľné a máte právo ho kedykoľvek odvolať
                bez vplyvu na zákonnosť spracúvania pred jeho odvolaním.</p>

            <p className={'my-3'}>V prípade, že ste naším klientom, môžeme Vaše kontaktné údaje využívať na marketingové
                účely aj na základe nášho oprávneného záujmu. V takom prípade spracúvame údaje najviac po dobu 5 rokov
                od Vašej poslednej návštevy. Proti tomuto spracúvaniu máte právo kedykoľvek namietať.</p>

            <h4>8. Príjemcovia údajov</h4>
            <p className={'my-3'}>Vaše údaje môžu byť poskytnuté:
                <ul>
                    <li>poskytovateľovi softvéru rezervačného systému a softvéru evidencie klientov, softvéru
                        prístupových QR kódov a evidencie kreditov, dátového úložiska a softvéru na spracúvanie platieb,
                        čo je predovšetkým spoločnosť CEE Investments s.r.o., IČO: 45901996 (iClub.sk),
                    </li>
                    <li>spoločnosti InBody Co., Ltd. (Kórejská republika) – len v prípade, že využijete službu
                        merania InBody, bližšie v bode 4,
                    </li>
                    <li>účtovníkovi, IT správcovi a poskytovateľom technických služieb (kamera),</li>
                    <li>externým trénerom, za účelom zabezpečenia a organizácie osobných a skupinových tréningov,
                    </li>
                    <li>štátnym orgánom (napr. daňový úrad) v prípade zákonnej povinnosti,</li>
                    <li>správcovi platobnej brány (prijímanie platieb - údaje z platobnej karty, identifikácie platiteľa
                        a poplatku).
                    </li>
                </ul>
            </p>

            <h4>9. Doba uchovávania údajov</h4>
            <p className={'my-3'}>
                <ul>
                    <li>osobné údaje klienta: po dobu trvania členstva + 4 roky,</li>
                    <li>údaje z merania InBody: 24 mesiacov od posledného merania, resp. po dobu balíka meraní +
                        primeraný čas na porovnanie, max. 3 roky,
                    </li>
                    <li>účtovné a daňové údaje: 10 rokov,</li>
                    <li>kamerové záznamy: max. 14 dní,</li>
                    <li>marketingové údaje: do odvolania súhlasu,</li>
                    <li>marketingové údaje na základe oprávneného záujmu (existujúci klienti): max. 5 rokov od
                        poslednej návštevy.
                    </li>
                </ul>
            </p>
            <h4>10. Zodpovedná osoba</h4>
            <p className={'my-3'}>Prevádzkovateľ nemá vzhľadom na povahu a rozsah spracúvania osobných údajov
                povinnosť ustanoviť zodpovednú osobu (DPO) podľa čl. 37 GDPR. Vo všetkých veciach týkajúcich sa
                ochrany osobných údajov nás môžete kontaktovať na e-maile info@formafitness.sk.</p>
            <h4>11. Práva dotknutej osoby</h4>
            <p className={'my-3'}>
                Máte právo:
                <ul>
                    <li>na prístup k svojim údajom,</li>
                    <li>na opravu nesprávnych údajov,</li>
                    <li>na vymazanie údajov („právo na zabudnutie“),</li>
                    <li>na obmedzenie spracúvania,</li>
                    <li>na námietku voči spracúvaniu,</li>
                    <li>na prenosnosť údajov,</li>
                    <li>na odvolanie súhlasu so spracúvaním osobných údajov, ak je spracúvanie založené na súhlase,
                        a to kedykoľvek, bez vplyvu na zákonnosť spracúvania pred jeho odvolaním,
                    </li>
                    <li>podať sťažnosť na Úrad na ochranu osobných údajov (www.dataprotection.gov.sk).</li>
                </ul>
            </p>
            <h4>12. Ako si uplatniť svoje práva</h4>
            <p className={'my-3'}>Svoje práva si môžete uplatniť e-mailom na: info@formafitness.sk, alebo písomne na
                adrese: rovenski s. r. o., Rovenská 668/2, 905 01 Senica</p>
        </>
    );
}

export default GdprPage;
